mutation UpdateContent($id: ID!, $input: UpdateContentInput!) {
  updateContent(id: $id, input: $input) {
    id
  }
}
